export const environment = {
  production: false,
  REACT_APP_ENV: 'development',
  REACT_APP_HOST: 'https://staging-priceless.flexiroam.com',
  REACT_APP_CLIENT_BASE_URL: 'https://sandbox-clientservices.flexiroam.com',
  REACT_APP_ENDUSER_BASE_URL: 'https://sandbox-enduserservices.flexiroam.com',
  REACT_APP_VENDOR_BASE_URL: 'https://sandbox-vendorservices.flexiroam.com',
  REACT_APP_PLAN_BASE_URL: 'https://sandbox-planservices.flexiroam.com',
  REACT_APP_TURNSTILE_SITE_KEY: '0x4AAAAAADEuVzr8lG0Pbt0o',
  STRIPE_PUBLIC_KEY: 'pk_test_oTR8ETp6qocbEsvetOoPbkCc',
  STRIPE_SECRET_KEY: 'sk_test_InyuLlHiDpVUKdUTn95He9v8',
};

console.log('✅ Loaded DEVELOPMENT environment');
